import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { usePreview } from '../contexts/PreviewContext';
import TermsModal from './TermsModal';
import ManagedDisclaimer from './ManagedDisclaimer';

const Footer = () => {
  const { theme } = useTheme();
  const { previewData, isPreviewMode } = usePreview();
  const [showTermsModal, setShowTermsModal] = useState(false);

  // Use preview branding if in preview mode, otherwise use regular theme
  const displayBranding = isPreviewMode && previewData?.branding
    ? previewData.branding
    : theme;

  const primaryColor = displayBranding.primary_color || '#072040';
  const secondaryColor = displayBranding.secondary_color || '#f0a500';
  const companyName = displayBranding.company_name || 'Drummond Capital Partners';

  return (
    <footer className="site-footer mt-auto py-4" style={{ backgroundColor: primaryColor, color: '#ffffff' }}>
      <div className="container">
        <div className="row">
          {/* Company Info */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3" style={{ color: secondaryColor }}>Drummond Capital Partners</h6>
            <p className="small mb-1">AFSL 534213</p>
            <p className="small mb-3">ABN 15 622 660 182</p>
            <p className="small mb-1">Telephone: 03 9131 8500</p>
            <p className="small mb-1">
              Email: <a href="mailto:enquiries@drummondcp.com" style={{ color: secondaryColor }}>enquiries@drummondcp.com</a>
            </p>
            <p className="small mb-0">
              <a href="https://www.drummondcp.com" target="_blank" rel="noopener noreferrer" style={{ color: secondaryColor }}>www.drummondcp.com</a>
            </p>
          </div>

          {/* Melbourne */}
          <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3" style={{ color: secondaryColor }}>Melbourne</h6>
            <p className="small mb-0">
              Level 11, 55 Collins Street,<br />
              Melbourne, VIC 3000
            </p>
          </div>

          {/* Brisbane */}
          <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3" style={{ color: secondaryColor }}>Brisbane</h6>
            <p className="small mb-0">
              Level 6, 200 Adelaide Street,<br />
              Brisbane, QLD 4000
            </p>
          </div>

          {/* Sydney */}
          <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3" style={{ color: secondaryColor }}>Sydney</h6>
            <p className="small mb-0">
              Level 11, 10 Carrington Street,<br />
              Sydney, NSW 2000
            </p>
          </div>

          {/* Perth */}
          <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3" style={{ color: secondaryColor }}>Perth</h6>
            <p className="small mb-0">
              Level 1/9 The Esplanade,<br />
              Perth WA 6000
            </p>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="row mt-4 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.2)' }}>
          <div className="col-12">
            <ManagedDisclaimer dkey="portal_footer" as="p" className="mb-0" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.7rem', lineHeight: '1.4' }} />
          </div>
        </div>

        {/* Copyright */}
        <div className="row mt-3 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div className="col-12 text-center">
            <p className="small mb-0" style={{ color: 'rgba(255,255,255,0.7)' }}>
              &copy; {new Date().getFullYear()} Drummond Capital Partners Pty Ltd
              <span className="mx-2">|</span>
              AFSL 534213
              <span className="mx-2">|</span>
              <button
                onClick={() => setShowTermsModal(true)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  color: secondaryColor,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontSize: 'inherit',
                  fontFamily: 'inherit'
                }}
              >
                Disclaimer &amp; Terms
              </button>
            </p>
          </div>
        </div>
      </div>

      <TermsModal show={showTermsModal} onClose={() => setShowTermsModal(false)} />
    </footer>
  );
};

export default Footer;
